(function() {
  const LOGO_URL = 'https://cdn.shopify.com/s/files/1/0598/5933/7349/files/image0.png?v=1774451414';
  
  const DESKTOP_SIZE = '8vw';   
  const TABLET_SIZE = '12vw';   
  const MOBILE_SIZE = '25vw';   

  const injectLogo = () => {
    const pName = document.querySelector('.p-name');
    
    if (pName && !document.querySelector('.logo-section')) {
      const style = document.createElement('style');
      style.textContent = `
        .logo-section {
          width: 100%;
          margin-bottom: 0px; /* Removed margin beneath logo */
          display: flex;
          justify-content: center;
          align-items: center;
          line-height: 0;   /* Prevents vertical spacing from text alignment */
        }
        .responsive-logo {
          display: block;
          width: ${DESKTOP_SIZE}; 
          max-width: 220px; 
          height: auto;
          object-fit: contain;
          margin: 0 auto;
        }

        @media screen and (max-width: 1024px) {
          .responsive-logo {
            width: ${TABLET_SIZE};
          }
        }

        @media screen and (max-width: 767px) {
          .responsive-logo {
            width: ${MOBILE_SIZE};
          }
        }
      `;
      document.head.appendChild(style);

      const container = document.createElement('div');
      container.className = 'logo-section';
      
      const img = document.createElement('img');
      img.src = LOGO_URL;
      img.className = 'responsive-logo';
      img.alt = 'Logo';

      container.appendChild(img);
      pName.parentNode.insertBefore(container, pName);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectLogo);
  } else {
    injectLogo();
  }
})();